<!-- Маленькая ссылка на транспорт через кликабельный госномер -->
<template>
  <BaseTooltip class="vehicle-entity-link__tooltip" position="top" max-width="320">
    <RouterLink
      class="vehicle-entity-link"
      :to="{ name: 'VehicleDetails', params: { id: vehicle.id } }"
      @click.stop
    >
      <VehicleRegNumberBadge
        v-if="vehicle.registration_number"
        :number="vehicle.registration_number"
        size="sm"
      />
      <span v-else class="vehicle-entity-link__empty-number">
        —
      </span>
    </RouterLink>

    <template #content>
      <div class="vehicle-entity-link-tooltip">
        <div class="vehicle-entity-link-tooltip__header">
          <VehicleRegNumberBadge
            v-if="vehicle.registration_number"
            :number="vehicle.registration_number"
            size="sm"
          />
          <span v-else class="vehicle-entity-link-tooltip__title">
            {{ fallbackTitle }}
          </span>
        </div>

        <div class="vehicle-entity-link-tooltip__rows">
          <div
            v-for="row in tooltipRows"
            :key="row.label"
            class="vehicle-entity-link-tooltip__row"
          >
            <span class="vehicle-entity-link-tooltip__label">
              {{ row.label }}
            </span>
            <span class="vehicle-entity-link-tooltip__value">
              {{ row.value }}
            </span>
          </div>
        </div>
      </div>
    </template>
  </BaseTooltip>
</template>

<script>
import VehicleRegNumberBadge from "@/components/Vehicle/VehicleRegNumberBadge.vue";
import { formatBigNumber } from "@/utils/numberUtils";
import { trailerTypeLabel, vehicleTypeLabel } from "@/utils/vehicleTypeUtils";

export default {
  name: "VehicleEntityLink",
  components: {
    VehicleRegNumberBadge,
  },
  props: {
    vehicle: {
      type: Object,
      required: true,
    },
  },
  computed: {
    fallbackTitle() {
      return this.vehicle.selector_name || this.vehicle.model || `ТС #${this.vehicle.id}`;
    },

    tooltipRows() {
      return [
        { label: "Модель", value: this.vehicle.model || "—" },
        { label: "Тип ТС", value: vehicleTypeLabel(this.vehicle.vehicle_type) || "—" },
        { label: "Вид для ЭДО", value: this.vehicle.edo_vehicle_type || "—" },
        { label: "Тип прицепа", value: trailerTypeLabel(this.vehicle.trailer_type) || "—" },
        { label: "Автопарк", value: this.vehicle.fleet_park?.name || "—" },
        { label: "Грузоподъёмность", value: this.formattedCapacity || "—" },
        { label: "Вместимость", value: this.formattedVolume || "—" },
      ];
    },

    formattedCapacity() {
      if (!this.vehicle.capacity_tons) return "";

      return `${formatBigNumber(this.vehicle.capacity_tons)} т`;
    },

    formattedVolume() {
      if (!this.vehicle.volume_m3) return "";

      return `${formatBigNumber(this.vehicle.volume_m3)} м³`;
    },
  },
};
</script>

<style scoped>
.vehicle-entity-link {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  max-width: 100%;
  color: inherit;
  text-decoration: none;
  vertical-align: middle;
}

.vehicle-entity-link__tooltip {
  width: fit-content;
  max-width: 100%;
}

.vehicle-entity-link:hover {
  opacity: 0.82;
}

.vehicle-entity-link-tooltip {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 230px;
}

.vehicle-entity-link-tooltip__header {
  display: flex;
  align-items: center;
  min-width: 0;
}

.vehicle-entity-link-tooltip__title {
  color: #fff;
  font-size: 13px;
  font-weight: 700;
}

.vehicle-entity-link-tooltip__rows {
  display: grid;
  gap: 6px;
}

.vehicle-entity-link-tooltip__row {
  display: grid;
  grid-template-columns: 96px minmax(0, 1fr);
  gap: 10px;
  align-items: start;
}

.vehicle-entity-link-tooltip__label {
  color: #cbd5e1;
  font-size: 11px;
  line-height: 1.25;
}

.vehicle-entity-link-tooltip__value {
  min-width: 0;
  overflow: hidden;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.25;
  text-overflow: ellipsis;
}

.vehicle-entity-link__empty-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 20px;
  color: #94a3b8;
  font-size: 12px;
  font-weight: 700;
  background: #f8fafc;
  border: 1px solid #cbd5e1;
  border-radius: 4px;
}
</style>
